import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { OperatorLineFieldComponent } from './operator-line-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    OperatorLineFieldComponent,
  ],
  exports: [
    OperatorLineFieldComponent,
  ],
})
export class OperatorLinesExportModule {}
